"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fractionizeAndisPlural = exports.fractionize = void 0;
const fraction_js_1 = __importDefault(require("fraction.js"));
const replaceAll_1 = require("./replaceAll");
const fractionToString = (fraction, skipPretty) => {
    const whole = Math.floor(fraction.n / fraction.d);
    const numerator = fraction.n % fraction.d;
    const prettyFraction = skipPretty
        ? `${numerator}/${fraction.d}`
        : replaceAll_1.safeTextToFraction(`${numerator}/${fraction.d}`);
    return whole
        ? `${whole}${prettyFraction.length > 1 ? " " : ""}${prettyFraction}`
        : `${prettyFraction}`;
};
exports.fractionize = (n, skipPretty) => {
    let fraction;
    try {
        fraction = fraction_js_1.default(n).simplify();
    }
    catch (err) {
        return `${n}`;
    }
    if (fraction.d === 1 || fraction.n === fraction.d) {
        return `${n}`;
    }
    return fractionToString(fraction, skipPretty);
};
exports.fractionizeAndisPlural = (n) => {
    let fraction;
    try {
        fraction = fraction_js_1.default(n);
    }
    catch (err) {
        return [`${n}`, false];
    }
    if (fraction.d === 1 || fraction.n === fraction.d) {
        return [`${n}`, fraction > 1];
    }
    return [fractionToString(fraction), fraction > 1];
};
//# sourceMappingURL=fractionize.js.map